// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"PresaleCodesTab_fullWidth__1rbIA"};